import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx } from "vue"

import { Routes } from '@/router/router.const';
import { useUserRolePermissions } from '@/services/UserRolePermissions/UserRolePermissions';
import { FeatureFlags } from '@/types/utils';
import elementsIds from '@/const/elementIds.json';
import SideMenuItem from '../components/sidemenu-item.vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'sidemenu-list.linux',
  props: {
    miniState: { type: Boolean },
    featureFlags: null,
    userRolePermissions: null
  },
  setup(__props: any) {



return (_ctx: any,_cache: any) => {
  const _component_q_list = _resolveComponent("q-list")!

  return (_openBlock(), _createBlock(_component_q_list, null, {
    default: _withCtx(() => [
      (!!__props.featureFlags?.dashboard)
        ? (_openBlock(), _createBlock(SideMenuItem, {
            key: 0,
            label: "Dashboard",
            route: _unref(Routes).Dashboard,
            "active-routes": [_unref(Routes).Dashboard, _unref(Routes).DashboardWorkloads, _unref(Routes).DashboardGridUtilization],
            "mini-state": __props.miniState,
            "data-testid": _unref(elementsIds).leftDrawer.sideMenuItems.dashboard
          }, null, 8, ["route", "active-routes", "mini-state", "data-testid"]))
        : _createCommentVNode("", true),
      _createVNode(SideMenuItem, {
        label: "Agents",
        route: _unref(Routes).Agents,
        "mini-state": __props.miniState,
        "data-testid": _unref(elementsIds).leftDrawer.sideMenuItems.agents
      }, null, 8, ["route", "mini-state", "data-testid"]),
      _createVNode(SideMenuItem, {
        label: "Builds",
        route: _unref(Routes).Builds,
        "mini-state": __props.miniState,
        "data-testid": _unref(elementsIds).leftDrawer.sideMenuItems.workloads,
        "active-routes": [_unref(Routes).Builds, _unref(Routes).BuildView, _unref(Routes).BuildSummary, _unref(Routes).BuildPerformanceMetrics]
      }, null, 8, ["route", "mini-state", "data-testid", "active-routes"]),
      (__props.userRolePermissions.authorize?.value?.users.visible)
        ? (_openBlock(), _createBlock(SideMenuItem, {
            key: 1,
            label: "Users",
            route: _unref(Routes).Users,
            "mini-state": __props.miniState,
            "data-testid": _unref(elementsIds).leftDrawer.sideMenuItems.users
          }, null, 8, ["route", "mini-state", "data-testid"]))
        : _createCommentVNode("", true),
      (__props.userRolePermissions.authorize?.value?.settings.visible.sideMenu)
        ? (_openBlock(), _createBlock(SideMenuItem, {
            key: 2,
            label: "Settings",
            route: _unref(Routes).Settings,
            "active-routes": [_unref(Routes).Settings, _unref(Routes).SettingsGeneral, _unref(Routes).SettingsBuildGroups, _unref(Routes).SettingsApiAccess, _unref(Routes).SettingsCloud],
            "mini-state": __props.miniState,
            "data-testid": _unref(elementsIds).leftDrawer.sideMenuItems.settings
          }, null, 8, ["route", "active-routes", "mini-state", "data-testid"]))
        : _createCommentVNode("", true),
      (__props.userRolePermissions.authorize?.value?.license.visible.sideMenu)
        ? (_openBlock(), _createBlock(SideMenuItem, {
            key: 3,
            label: "License",
            route: _unref(Routes).License,
            "mini-state": __props.miniState,
            "data-testid": _unref(elementsIds).leftDrawer.sideMenuItems.license
          }, null, 8, ["route", "mini-state", "data-testid"]))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }))
}
}

})